module.exports = __webpack_public_path__ + "img/logo1.58e49d4d.png";